module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Weight1-838033976e8e08e129e95932f12fc2dd.svg";